import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalAlert } from '@~components/modal-alert/ModalAlert';

export const GatPlanInfoModal = memo(() => {
  const { t } = useTranslation();

  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <FontAwesomeIcon
        icon={faInfoCircle}
        className="tx-primary interactive"
        size="2x"
        onClick={() => setOpenModal(true)}
        title={`${t('common.information')}`}
      />

      <ModalAlert
        key="modal-for-gat-info"
        proceed={setOpenModal}
        show={openModal}
        title={t('pages.account.staking.content.gat-plan.title') + ''}
        cancelLabel={`${t('common.action.close')}`}
        centered={false}
        size="lg"
        noOk
        enableEscape
        content={
          <div className="modal-content-bg">
            <div className="text-center mb-6">
              <FontAwesomeIcon icon={faTriangleExclamation} className="tx-primary me-3" size="2x" />
              <FontAwesomeIcon icon={faTriangleExclamation} className="tx-primary me-3" size="2x" />
              <FontAwesomeIcon icon={faTriangleExclamation} className="tx-primary me-3" size="2x" />
              <h4>{t('pages.account.staking.content.gat-plan.unavailable-title')}</h4>
              <p>{t('pages.account.staking.content.gat-plan.unavailable-text')}</p>
            </div>
            <p>{t('pages.account.staking.content.gat-plan.text.1')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.2')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.3')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.4')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.5')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.6')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.7')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.8')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.9')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.10')}</p>
            <p>{t('pages.account.staking.content.gat-plan.text.11')}</p>
          </div>
        }
      />
    </>
  );
});
